import React, { useState } from "react";
import { forgotPassword } from "../../services/api";
import { FaEnvelope, FaSpinner, FaCheckCircle } from "react-icons/fa";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <FaCheckCircle className="text-green-600 w-8 h-8" />
        </div>
        <h3 className="text-xl font-bold text-gray-900">Check your email</h3>
        <p className="text-gray-600 text-sm">
          If <strong>{email}</strong> is registered, a password reset link has been sent. Check your inbox (and spam folder).
        </p>
        <a href="/login" className="inline-block mt-4 text-green-700 font-semibold hover:underline text-sm">
          ← Back to Login
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <FaEnvelope className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          type="email"
          placeholder="Enter your email address"
          className="w-full border border-gray-300 focus:border-green-500 focus:ring-1 focus:ring-green-500 pl-10 pr-4 py-3 rounded-lg text-sm outline-none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      {error && <p className="text-red-600 text-sm">{error}</p>}
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 rounded-lg text-white font-semibold bg-green-700 hover:bg-green-800 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {loading ? <><FaSpinner className="animate-spin" /> Sending...</> : "Send Reset Link"}
      </button>
      <p className="text-center text-sm text-gray-500">
        Remembered your password?{" "}
        <a href="/login" className="text-green-700 font-semibold hover:underline">Back to Login</a>
      </p>
    </form>
  );
}
